export const readAsArrayBufferAsync = (file: File): Promise<FileReader['result']> => new Promise((resolve, reject) => {
  const reader = new FileReader()
  reader.onload = () => {
    resolve(reader.result)
  }
  reader.onerror = () => reject(reader.error ?? new Error('Failed to read file as an ArrayBuffer'))
  reader.readAsArrayBuffer(file)
})

export const readAsDataURLAsync = (file: File): Promise<string> => new Promise((resolve, reject) => {
  const reader = new FileReader()
  reader.onload = () => {
    resolve(reader.result as string)
  }
  reader.onerror = reject
  reader.readAsDataURL(file)
})
